import classNames from 'classnames'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize'
import 'react-dates/lib/css/_datepicker.css'
import { CalendarIcon } from '../../assets/svg/hartu'
import Button from '../../atoms/Button/Button'
import BODY_OVERFLOW_HIDDEN from '../../constants/styles'
import t from '../../i18n/translations/translations'
import './DatePickerRange.css'

function DatePickerRange({
    availableDates,
    closeModal,
    dateProp,
    disabled,
    id,
    isModal,
    lang,
    months,
    onChangedDates,
    placeholder,
    required,
    setDayFocused,
}) {
    const [date, setDate] = useState(null)
    const [isFocused, setIsFocused] = useState(false)

    const handleFocus = ({ focused }) => {
        if (!isModal) {
            setDayFocused(focused)
        }
        setIsFocused(focused)
    }

    
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [focusedInput, setFocusedInput] = useState(null);


    const handleCloseModal = () => {
        closeModal()
        document.body.classList.remove(BODY_OVERFLOW_HIDDEN)
    }

    const handleChange = (startDate, endDate) => {
        setStartDate(startDate);
        if (endDate) {
            setEndDate(endDate, onChangedDates(startDate, endDate));
        }
    }

    useEffect(() => {
        if (date === null && dateProp && date !== dateProp) {
            setDate(dateProp)
        }

    }, [date, dateProp])

    const isBlocked = (day) => {
        const today = moment().endOf('day')

        if (day?.isBefore(today, 'day')) {
            return true
        }

        if (availableDates?.length) {
            return !availableDates.some((availableDate) =>
                day.isSame(availableDate, 'day')
            )
        }

        return true
    }

    moment.locale(lang || 'es')

    const isOpened = isModal ? true : isFocused

    return (
        <div
            className={classNames('date-picker-wrapper', {
                'date-picker-wrapper__focused': isFocused,
            })}
        >
            <div
                className={classNames('date-picker', {
                    'date-picker__with_modal': isModal,
                    'date-picker__focused': isFocused,
                    'date-picker__disabled': disabled,
                })}
            >
                {!isFocused && !isModal ? (
                    <span className="date-picker__icon">
                        <CalendarIcon />
                    </span>
                ) : null}
                <DateRangePicker
                    startDate={startDate}
                    startDateId="start_date_id"
                    startDatePlaceholderText={t.start_date[lang]}
                    endDate={endDate}
                    endDateId="end_date_id"
                    endDatePlaceholderText={t.end_date[lang]}
                    onDatesChange={({ startDate, endDate }) => {
                        handleChange(startDate, endDate);
                    }}
                    focusedInput={focusedInput}
                    onFocusChange={input => setFocusedInput(input)}
                    hideKeyboardShortcutsPanel
                    numberOfMonths={1}
                    readOnly={false}
                    required={true}
                    minDate={moment().toDate()}
                    minimumNights={0}
                    isOutsideRange={day =>
                        day.isBefore(availableDates[0], 'day') || day.isAfter(availableDates[availableDates.length - 1], 'day')
                    }
                />
            </div>
            {isOpened && (
                <div className="date-picker__button">
                    <Button aria-haspopup="dialog" onClick={handleCloseModal}>
                        {date
                            ? t.select_this_day[lang]
                            : t.date_picker_close[lang]}
                    </Button>
                </div>
            )}
        </div>
    )
}
export default DatePickerRange
